import { Component, OnInit } from '@angular/core';
import { MainPageService } from '../../main-page.service';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { BasicDictionaryModel } from '../../../models/dictionaries/basic-dictionary.model';
declare var $: any;

@Component({
  selector: 'app-pipe-material-types-grid',
  template: `<!-- Create Modal -->
<div class="modal" id="addModal">
    <div class="modal-dialog">
        <div class="modal-content">
            <form class="form-group" [formGroup]="formGroup">
                <div class="modal-content">

                    <!-- Modal Header -->
                    <div class="modal-header">
                        <button type="button" class="close" data-dismiss="modal">&times;</button>
                    </div>

                    <!-- Modal body -->
                    <div class="modal-body display-flex">
                        <div>
                            <div>
                                <div class="display-flex">
                                    <span class="modal-label">Name:</span>
                                    <input type="text" [(ngModel)]="editedPipeMaterialType.name" formControlName="name">
                                </div>
                                <div class="display-flex">
                                    <span class="modal-label">Code:</span>
                                    <input type="text" [(ngModel)]="editedPipeMaterialType.code" formControlName="code">
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Modal footer -->
                    <div class="modal-footer">
                        <button type="button" class="btn btn-danger red-button" data-dismiss="modal">Cancel</button>
                        <button type="submit" class="btn btn-primary save-button" data-dismiss="modal" [disabled]="formGroup.invalid" (click)="saveNewPipeMaterialType()">Save</button>
                    </div>
                </div>
            </form>
        </div>
    </div>
</div>

<!-- Edit Modal -->
<div class="modal" id="editModal">
    <div class="modal-dialog">
        <div class="modal-content">
            <form class="form-group" [formGroup]="formGroup">
                <div class="modal-content">

                    <!-- Modal Header -->
                    <div class="modal-header">
                        <button type="button" class="close" data-dismiss="modal">&times;</button>
                    </div>

                    <!-- Modal body -->
                    <div class="modal-body display-flex">
                        <div>
                            <div>
                                <div class="display-flex">
                                    <span class="modal-label">Name:</span>
                                    <input type="text" [(ngModel)]="editedPipeMaterialType.name" formControlName="name">
                                </div>
                                <div class="display-flex">
                                    <span class="modal-label">Code:</span>
                                    <input type="text" [(ngModel)]="editedPipeMaterialType.code" formControlName="code">
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Modal footer -->
                    <div class="modal-footer">
                        <button type="button" class="btn btn-danger red-button" data-dismiss="modal">Cancel</button>
                        <button type="submit" class="btn btn-primary save-button" data-dismiss="modal" [disabled]="formGroup.invalid" (click)="editPipeMaterialType()">Save</button>
                    </div>
                </div>
            </form>
        </div>
    </div>
</div>

<!-- Delete Modal -->
<div class="modal" id="deleteModal">
    <div class="modal-dialog">
        <div class="modal-content">

            <!-- Modal Header -->
            <div class="modal-header">
                <button type="button" class="close" data-dismiss="modal">&times;</button>
            </div>

            <!-- Modal body -->
            <div class="modal-body">
                <span class="modal-label">Do you want to delete this Pipe material type?</span>
            </div>

            <!-- Modal footer -->
            <div class="modal-footer">
                <button type="button" class="btn btn-danger" data-dismiss="modal">Cancel</button>
                <button type="submit" class="btn btn-primary" data-dismiss="modal" (click)="deletePipeMaterialType(editedPipeMaterialType)">Delete</button>
            </div>
        </div>
    </div>
</div>


<div class="input-effect">
    <input class="effect1" type="text" placeholder="">
    <label>Search</label>
    <span class="focus-border"></span>
</div>
<button class="red-button" type="button" data-toggle="modal" data-target="#addModal" (click)="prepareCreate()">Create</button>

<table>
    <tr>
        <th *ngFor="let header of headers">{{header}}</th>
    </tr>
    <tr *ngFor="let pipeMaterialType of pipeMaterialTypesGridData, let row_no = index">
        <td>{{pipeMaterialType.name}}</td>
        <td>{{pipeMaterialType.code}}</td>
        <td class="columnWithIcons">
            <button type="button" class="btn editBtn" data-toggle="modal" data-target="#editModal" (click)="setChoosenElement(pipeMaterialType, row_no)">
                <i class="fa fa-edit"></i>
            </button>
            <button type="button" class="btn deleteBtn" data-toggle="modal" data-target="#deleteModal" (click)="setChoosenElement(pipeMaterialType, row_no)">
                <i class="fa fa-trash"></i>
            </button>
        </td>
    </tr>
</table>`,
  styles: [`table{font-family:arial,sans-serif;border-collapse:collapse;width:100%}td,th{border:1px solid #ddd;text-align:left;padding:8px}tr:nth-child(even){background-color:#ddd}.modal-label{width:110px}.display-flex{display:flex;align-items:center;margin-bottom:10px}.search-input{border:none;border-bottom:1px solid gray;outline:0;margin-right:10px}`]
})
export class PipeMaterialTypesGridComponent implements OnInit {
  isPipeMaterialTypesHidden = true;
  pipeMaterialTypesGridData: BasicDictionaryModel[];
  editedPipeMaterialType = new BasicDictionaryModel();
  rowNumber: number;
  public formGroup: FormGroup;
  headers: string[] = ['Name', 'Code', ''];

  constructor(private mainPageService: MainPageService) {}

  public ngOnInit(): void {
    this.loadGridDataFromDb();
    this.mainPageService.deletePipeFunctionSubject.subscribe( (value) => {
      this.pipeMaterialTypesGridData = this.pipeMaterialTypesGridData.filter(x => x._id !== value);
    });
    this.createForm();
  }

  loadGridDataFromDb() {
    this.mainPageService.loadAllPipeMaterialTypes().subscribe((response) => {
      this.pipeMaterialTypesGridData = response.sort(function (a, b) {
        return (a.name < b.name) ? -1 : 1;
      });
    });
  }

  toggle() {
    const actionButtons = $('.mat-icon-button');
    $(actionButtons[1]).css('visibility', 'hidden');
    for (let i = 2; i < actionButtons.length; i += 2) {
        $(actionButtons[i]).css('visibility', 'hidden');
    }
    this.isPipeMaterialTypesHidden = !this.isPipeMaterialTypesHidden;
  }

  saveNewPipeMaterialType() {
    this.mainPageService.addNewPipeMaterialTypeIntoDb(JSON.stringify(this.editedPipeMaterialType)).subscribe((response) => {
      this.editedPipeMaterialType._id = response._id;
      this.editedPipeMaterialType.id = response.id;
      this.pipeMaterialTypesGridData.push(this.editedPipeMaterialType);
      this.editedPipeMaterialType = new BasicDictionaryModel();
    });
  }

  setChoosenElement(element, row) {
    this.editedPipeMaterialType = {
      ...element,
    };
    this.rowNumber = row;
    this.createForm();
  }

  editPipeMaterialType() {
    console.log(this.pipeMaterialTypesGridData[this.rowNumber]);
    Object.assign(this.pipeMaterialTypesGridData[this.rowNumber], this.editedPipeMaterialType);
    this.mainPageService.updatePipeMaterialTypeInDb(JSON.stringify(this.editedPipeMaterialType)).subscribe(() => { });
  }

  deletePipeMaterialType(element) {
    this.mainPageService.removePipeMaterialType(element._id).subscribe(() => { }, () => { });
    this.mainPageService.deletePipeMaterialTypeSubject.next(element._id);
  }

  public prepareCreate() {
    this.editedPipeMaterialType = new BasicDictionaryModel();
    this.createForm();
  }

  private createForm() {
    this.formGroup = new FormGroup({
      name: new FormControl(this.editedPipeMaterialType.name, Validators.required),
      code: new FormControl(this.editedPipeMaterialType.code)
    });
  }
}
